import React from "react";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import ContactLandingPage from "../Components/ContactLandingPage";

const Contact = () => {
  return (
    <>
      <Navbar />
      <ContactLandingPage />
      <Footer />
    </>
  );
};

export default Contact;
